import { NavLink } from "react-router-dom";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import "./SideNavigation.scss";
import { ReactComponent as Home } from "../images/Icon_home.svg";
import { ReactComponent as Students } from "../images/Icon_users.svg";
import { ReactComponent as User } from "../images/user_icon.svg";
import { ReactComponent as Guide } from "../images/icon_ai_guide.svg";
import { ReactComponent as Experience } from "../images/icon_experience.svg";
import { ReactComponent as Element } from "../images/icon_elements.svg";
import { ReactComponent as Environment } from "../images/icon_environments.svg";
import { ReactComponent as Collection } from "../images/icon_collections.svg";
import { ReactComponent as System } from "../images/icon_systems.svg";
import { Divider } from "@mui/material";
import PermissionGate from "./PermissionGate";
import { useAuth } from "../context/AuthContext";
import { isEducatorRole } from "../utility/accountRoles";

const SideNavigation = ({ isOpen, onClose }) => {
  const { roleName } = useAuth();
  const getNavClassName = ({ isActive }) => (isActive ? "nav-link active" : "nav-link");
  const handleLinkClick = () => onClose?.();
  const shouldHideExperiencesLink = isEducatorRole(roleName);

  return (
    <>
      {isOpen && <div className="side-navigation__backdrop" onClick={onClose} />}
      <div className={`side-navigation ${isOpen ? "is-open" : ""}`}>
        <div className="top">
          <NavLink to="/" className={getNavClassName} end onClick={handleLinkClick}>
            <Home />
            Home
          </NavLink>
          <PermissionGate requiredPermission="viewDashboard">
            <NavLink to="/dashboard" className={getNavClassName} onClick={handleLinkClick}>
              <QueryStatsRoundedIcon />
              Analytics
            </NavLink>
          </PermissionGate>
          <PermissionGate requiredPermission="viewDashboard">
            <NavLink to="/sessions" className={getNavClassName} onClick={handleLinkClick}>
              <Students />
              Student sessions
            </NavLink>
          </PermissionGate>
          <div className="side-navigation__divider-wrap">
            <Divider variant="fullWidth" />
          </div>
          {!shouldHideExperiencesLink && (
            <PermissionGate requiredPermission="crudExperiences">
              <NavLink to="/experiences" className={getNavClassName} onClick={handleLinkClick}>
                <Experience />
                Experiences
              </NavLink>
            </PermissionGate>
          )}
          <PermissionGate requiredPermission="crudGuides" grayOutIfUnauthorized>
            <NavLink to="/guides" className={getNavClassName} onClick={handleLinkClick}>
              <Guide />
              Guides <br />
              (BETA)
            </NavLink>
          </PermissionGate>
          <div className="side-navigation__divider-wrap">
            <Divider variant="fullWidth" />
          </div>
          <PermissionGate requiredPermission="crudContent">
            <>
              <NavLink to="/elements" className={getNavClassName} onClick={handleLinkClick}>
                <Element />
                Elements
              </NavLink>
              <NavLink to="/environments" className={getNavClassName} onClick={handleLinkClick}>
                <Environment />
                Environments
              </NavLink>
              <NavLink to="/systems" className={getNavClassName} onClick={handleLinkClick}>
                <System />
                Systems
              </NavLink>
              <NavLink to="/collections" className={getNavClassName} onClick={handleLinkClick}>
                <Collection />
                Collections
              </NavLink>
            </>
          </PermissionGate>
        </div>
        <div className="bottom">
          <NavLink to="/account" className={getNavClassName} onClick={handleLinkClick}>
            <User />
            Account
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default SideNavigation;
